import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { type SelectOption } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'
import type User from 'modules/core/store/models/User'

import permissionGroups from 'modules/permissions/store/collections/permissionGroups'

import useMoveUserToPermissionGroup from '../../hooks/useMoveUserToPermissionGroup'

interface Props {
  userId: number
  onClose: () => void
}

const ChangeGroup = ({ userId, onClose }: Props) => {
  const [moveUser, movingUser] = useMoveUserToPermissionGroup()
  const user = React.useMemo<User | null | undefined>(() => users.get(Number(userId)), [userId])

  const options = React.useMemo<SelectOption[]>(() => {
    if (!user) return []

    return permissionGroups
      .filter((pg) => pg.attributes.id !== user.attributes.permissions_group_id)
      .map((pg) => ({
        label: pg.attributes.name,
        value: pg.attributes.id,
      }))
  }, [user])

  const form = React.useMemo(
    () =>
      new Form(
        {
          permissions_group_id: options[0]?.value,
        },
        {
          permissions_group_id: 'number',
        }
      ),
    [options]
  )

  const onSubmit = async (closePortal: ClosePortalFn) => {
    await moveUser({
      permissionGroupId: parseInt(form.get('permissions_group_id').value),
      accessId: userId,
    })
    closePortal()
  }

  if (!user) return null

  return (
    <Modal
      illustration="user-move"
      title={i18n.t('settings.permissions.group.modal.title')}
      description={i18n.t('settings.permissions.group.modal.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button submit disabled={movingUser}>
          {i18n.t('settings.permissions.group.modal.submit', {
            user: user.fullName(),
          })}
        </Button>
      }
    >
      <Select
        label={i18n.t('settings.permissions.group.modal.group')}
        field={form.get('permissions_group_id')}
        options={options}
      />
    </Modal>
  )
}

export default observer(ChangeGroup)
